import BaseContact from './base-contact.js';

'use strict';

export class Application extends BaseContact {
	constructor(args = []) {
		super(args);
		
		this.contact = {
			id: "contact-form",
			route: "/api/ayamimuto/v1/mail/"
		}
		
		this.setLog('[Extension] ', "Contact Form");
		this.setForms();
	}
};

window.Application = new Application();